import Vue from 'vue'
import Router from 'vue-router'

import Home from './pages/Home'
import Gallery from './pages/Gallery'
import Inventory from './pages/Inventory'
import Faq from './pages/Faq'
import VuetifyComponents from './pages/VuetifyComponents'
import Quote from './pages/Quote'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: Gallery
    },
    {
      path: '/inventory',
      name: 'inventory',
      component: Inventory
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq
    },
    {
      path: '/vuetify-components',
      name: 'vuetify-components',
      component: VuetifyComponents
    },
    {
      path: '/quote',
      name: 'quote',
      component: Quote
    }
  ]
})
